module.exports = __webpack_public_path__ + "static/yoga-cdb3bdbd0ef2f6c75fc263343235d754.svg";